import React from 'react';
import PropTypes from 'prop-types';
import { PropsContext } from '@uhg-abyss/web/hooks/usePropsContext/PropsContext';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { ActionRequiredWidget } from './ActionRequiredWidget';

export const Widget = (props) => {
  const widgetProps = { ...props };
  const theme = createTheme('uhc', { enterpriseFont: true });
  return (
    <ThemeProvider theme={theme}>
      <PropsContext.Provider value={widgetProps}>
        <ActionRequiredWidget />
      </PropsContext.Provider>
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/ActionRequiredWidget';

Widget.propTypes = {
  data: PropTypes.shape({
    user: PropTypes.shape({}),
    admissionSections: PropTypes.arrayOf(PropTypes.shape({})),
    claimsSections: PropTypes.arrayOf(PropTypes.shape({})),
    doclibSections: PropTypes.arrayOf(PropTypes.shape({})),
    mppSections: PropTypes.arrayOf(PropTypes.shape({})),
    priorAuthSections: PropTypes.arrayOf(PropTypes.shape({})),
    actionRequiredFilter: PropTypes.bool.isRequired,
  }),
};

Widget.defaultProps = {
  data: {
    admissionSections: [],
    claimsSections: [],
    doclibSections: [],
    mppSections: [],
    priorAuthSections: [],
  },
};
